import { Injectable } from "@angular/core";
import { noop } from "rxjs";

import { LoggingFactory } from "../logging/logging.factory";
import { DocumentRef } from "../platform/document";
import { PlatformService } from "../platform/platform.service";
import { WindowRef } from "../platform/window";
import { ThemeValueService } from "../utils/theme-value.service";

import { GtmTelemetryService } from "./gtm-telemetry.service";
import { DEFAULT_EXPERIMENT_VARIANT, VirtualPageView } from "./telemetry.model";

@Injectable({
	providedIn: "root",
	useFactory: (
		platformService: PlatformService,
		loggingFactory: LoggingFactory,
		windowRef: WindowRef,
		documentRef: DocumentRef,
		valueService: ThemeValueService
	) =>
		platformService.isServer
			? new NoopTelemetryService()
			: new GtmTelemetryService(loggingFactory, windowRef, documentRef, valueService),
	deps: [PlatformService, LoggingFactory, WindowRef, DocumentRef, ThemeValueService],
})
export abstract class TelemetryService {
	abstract track(event: Record<string, any>): void;

	// this tracking is so special here because it requires url obfuscation from user sensitive data
	abstract trackVirtualPageView(info: VirtualPageView): void;

	abstract getExperimentVariant(experimentName: string, waitFor: number): Promise<string>;
}

export class NoopTelemetryService implements TelemetryService {
	track() {
		return noop();
	}

	trackVirtualPageView() {
		return noop();
	}

	getExperimentVariant() {
		return Promise.resolve(DEFAULT_EXPERIMENT_VARIANT);
	}
}
